// extracted by mini-css-extract-plugin
module.exports = {"NewsList":"NewsList_NewsList__1Kbq6","NewsListItem":"NewsList_NewsListItem__2XGtm","NoArticles":"NewsList_NoArticles__3frFw"};